export default __webpack_public_path__ + "static/media/linkedin_disabled.755ee7aa.png";